import { useId } from 'react';

/** original multi-currency icon for reference @see "src/assets/images/custom/multiCurrency.svg" */
export const MultiCurrencyIconWithColor = ({
  signColor = 'white',
  mainColor = '#17181C',
  secondaryColor = '#6A6F7B',
  height = 20,
  width = 20,
}: {
  signColor?: string;
  mainColor?: string;
  secondaryColor?: string;
  height?: number;
  width?: number;
}) => {
  const titleId = useId();
  const clipPathId = useId();

  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-labelledby={titleId}
    >
      <title id={titleId}>Multi-currency icon</title>

      <g clipPath={`url(#${clipPathId})`}>
        <circle
          cx='12'
          cy='12'
          r='7.75'
          fill={secondaryColor}
          stroke='white'
          strokeWidth='1.5'
        />
        <circle
          cx='8'
          cy='8'
          r='7.75'
          fill={mainColor}
          stroke='white'
          strokeWidth='1.5'
        />
        <path
          d='M10.3865 9.1095C10.3865 10.05 9.712 10.8575 8.439 11.0475V12.045H7.3275V11.057C6.216 10.905 5.4465 10.221 5.285 9.119H6.4725C6.6245 9.708 7.1185 10.0595 7.8405 10.0595C8.781 10.0595 9.1705 9.651 9.1705 9.1095C9.1705 7.6275 5.5035 8.7675 5.5035 6.1455C5.5035 5.1765 6.1875 4.4545 7.3275 4.293V3.305H8.439V4.3025C9.484 4.483 10.092 5.1575 10.244 6.079H9.0565C8.9235 5.6135 8.534 5.2905 7.869 5.2905C7.09 5.2905 6.7195 5.68 6.7195 6.1455C6.7195 7.694 10.3865 6.611 10.3865 9.1095Z'
          fill={signColor}
        />
      </g>

      <defs>
        <clipPath id={clipPathId}>
          <rect width='20' height='20' fill='black' />
        </clipPath>
      </defs>
    </svg>
  );
};
